import { render, staticRenderFns } from "./ColumnProductCostPrice.vue?vue&type=template&id=178995db"
import script from "./ColumnProductCostPrice.vue?vue&type=script&lang=js"
export * from "./ColumnProductCostPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports